import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@/components/ui/alert-dialog';
import { toast } from '@/components/ui/toaster';
import {
  useDeleteWorkGroupFolder,
  workgroupsMutationErrorMessage,
} from '@/hooks/use-workgroups';

interface DeleteFolderDialogProps {
  workGroupId: string;
  folderId: string;
  folderName: string;
  parentId?: string | null;
  privateAccessReason?: string;
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export function DeleteFolderDialog({
  workGroupId,
  folderId,
  folderName,
  parentId,
  privateAccessReason,
  open,
  onOpenChange,
}: DeleteFolderDialogProps) {
  const mutation = useDeleteWorkGroupFolder();

  const handleDelete = () => {
    mutation.mutate(
      {
        workGroupId,
        folderId,
        parentId,
        privateAccessReason,
      },
      {
        onSuccess: () => {
          toast({ title: 'Folder moved to trash' });
          onOpenChange(false);
        },
        onError: (err) => {
          toast({ title: workgroupsMutationErrorMessage(err), variant: 'destructive' });
        },
      },
    );
  };

  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>Delete folder?</AlertDialogTitle>
          <AlertDialogDescription>
            &ldquo;{folderName}&rdquo; will be moved to trash. Subfolders and files may remain until
            restored or permanently removed.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel>Cancel</AlertDialogCancel>
          <AlertDialogAction
            disabled={mutation.isPending}
            onClick={(e) => {
              e.preventDefault();
              handleDelete();
            }}
          >
            Delete
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
